<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="title-h3">프로토콜</div>
    <el-button size="small" @click="exportProtocolList()"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
  </el-row>
  <hr class="mr-b20">
  <!-- TCP 연결 테이블 -->
  <div class="mr-b30">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">TCP 연결 테이블</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{tcpReloadTime}}</em></span>
        <el-button size="small" @click="loadTcpConnInfoList()" type="primary">TCP 연결테이블 정보 갱신</el-button>
        <w-header-search-button @click="tcpShowSearchTool = !tcpShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading.tcp" :data="dataList.tcpData" :columns="tcpColumns" :pagination="false" :show-custom-header="true" :show-search-tool="tcpShowSearchTool" style="width:100%;" :column-default="columnDefault">
    </el-table-wrapper>
  </div>
  <!-- STP 정보 -->
  <div class="mr-b30">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">STP 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{stpCheckDatetime}}</em></span>
        <el-button size="small" @click="loadStpInterfaceList()" type="primary">STP 정보 갱신</el-button>
        <w-header-search-button @click="stpShowSearchTool = !stpShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading.stp" :data="dataList.stpData" :columns="stpColumns" :pagination="false" :show-custom-header="true" :show-search-tool="stpShowSearchTool" :column-default="columnDefault">
    </el-table-wrapper>
  </div>
  <!-- VRRP 정보 -->
  <div class="mr-b30" v-if="!isControllerDevice">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">VRRP 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{vrrpCheckDatetime}}</em></span>
        <el-button size="small" @click="loadNetworkVrrpList()" type="primary">VRRP 정보 갱신</el-button>
        <w-header-search-button @click="vrrpShowSearchTool = !vrrpShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading.vrrp" :data="dataList.DISK" :columns="vrrpColumns" :pagination="false" :show-custom-header="true" :show-search-tool="vrrpShowSearchTool" style="width:100%;" :column-default="columnDefault">
    </el-table-wrapper>
  </div>
  <!-- 이중화(HSRP) 정보 -->
  <div v-if="!isControllerDevice">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="title-h4 tit">이중화(HSRP) 정보</div>
      <div>
        <span class="mr-r15">최근 수집시간 : <em>{{hsrpCheckDatetime}}</em></span>
        <el-button size="small" @click="loadNetworkHsrpList()" type="primary">이중화 정보 갱신</el-button>
        <w-header-search-button @click="hsrpShowSearchTool = !hsrpShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading.hsrp" :data="dataList.NETWORK" :columns="hsrpColumns" :pagination="false" :show-custom-header="true" :show-search-tool="hsrpShowSearchTool" style="width:100%;" :column-default="columnDefault">
    </el-table-wrapper>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WProtocolInfoNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      tcpShowSearchTool: false,
      stpShowSearchTool: false,
      vrrpShowSearchTool: false,
      hsrpShowSearchTool: false,
      stpCheckDatetime: null,
      vrrpCheckDatetime: null,
      hsrpCheckDatetime: null,
      tcpReloadTime: null,
      params: {
        netdeviceId: null,
        objId: null,
      },
      dataList: {
        tcpData: null,
        stpData: null,
        vrrpData: null,
        hsrpData: null,
      },
      loading: {
        tcp: false,
        stp: false,
        vrrp: false,
        hsrp: false,
      },
      tcpColumns: [
        {
          prop: 'localAddress',
          label: '로컬 IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'localPort',
          label: '로컬 포트',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'remoteAddress',
          label: '원격지 IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'remotePort',
          label: '원격지 포트',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'state',
          label: '상태',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      stpColumns: [
        {
          prop: 'vlanName',
          label: 'VLAN',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceIfindex',
          label: '인덱스',
          width: 100,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'port',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceAlias',
          label: '약칭',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceName',
          label: '인터페이스 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'rootPriority',
          label: 'Root Priority',
          width: 130,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'localPriority',
          label: 'Local Priority',
          width: 130,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'state',
          label: '상태',
          width: 150,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      vrrpColumns: [
        {
          prop: 'netinterfaceDevicename',
          label: '인터페이스 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceAlias',
          label: '인터페이스 별칭',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrId',
          label: '가상 라우터 아이디',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrPriority',
          label: '우선 순위',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'preemptMode',
          label: '선점 모드',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrState',
          label: '가상 라우터 상태',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrAdminState',
          label: '운영 상태',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrUpTime',
          label: '운영 시간',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrIpaddress',
          label: '가상 라우터 IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'vrMacaddress',
          label: '가상 라우터 MAC 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'masterIpaddress',
          label: '마스터 IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      hsrpColumns: [
        {
          prop: 'netinterfaceDevicename',
          label: '인터페이스 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'priority',
          label: '우선순위',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'state',
          label: '상태',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'activeNode',
          label: '활성 노드',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'standbyIp',
          label: '예비 IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'virtualIp',
          label: '가상 IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.params.netdeviceId = this.nodeParams.netdeviceId;
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.netdeviceId = this.nodeParams.netdeviceId;
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  computed: {
    isControllerDevice() {
      if (this.nodeParams.objtypeId === 'AP_CONTROLLER') {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadStore() {
      if (!isNil(this.params) && this.activeTab === this.$options.name) {
        if (!this.isControllerDevice) {
          this.loadNetworkVrrpList();
          this.loadNetworkHsrpList();
        }
        this.loadStpInterfaceList();
        this.loadTcpConnInfoList();
      }
    },
    loadNetworkVrrpList() {
      this.loading.vrrp = true;
      netdeviceInfoAPI
        .getNetworkVrrpList(this.params)
        .then((response) => {
          if (response.data.success) {
            this.dataList.vrrpData = response.data.data.data;
            this.vrrpCheckDatetime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'VRRP 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'VRRP 정보', false));
        })
        .finally(() => {
          this.loading.vrrp = false;
        });
    },
    loadNetworkHsrpList() {
      this.loading.hsrp = true;
      netdeviceInfoAPI
        .getNetworkHsrpList(this.params)
        .then((response) => {
          if (response.data.success) {
            this.dataList.hsrpData = response.data.data.data;
            this.hsrpCheckDatetime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이중화(HSRP) 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이중화(HSRP) 정보', false));
        })
        .finally(() => {
          this.loading.hsrp = false;
        });
    },
    loadStpInterfaceList() {
      this.loading.stp = true;
      netdeviceInfoAPI
        .getStpInterfaceList(this.params)
        .then((response) => {
          if (response.data.success) {
            this.dataList.stpData = response.data.data.data;
            this.stpCheckDatetime = this.checkDatetimeFormatter(response.data.data.checkDatetime);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'STP 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'STP 정보', false));
        })
        .finally(() => {
          this.loading.stp = false;
        });
    },
    loadTcpConnInfoList() {
      this.loading.tcp = true;
      netdeviceInfoAPI
        .getTcpConnectionInformationList({
          objId: this.nodeParams.objId,
        })
        .then((response) => {
          if (response.data.success) {
            this.dataList.tcpData = response.data.data;
            this.tcpReloadTime = getDateToString(new Date().getTime());
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'TCP 연결 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'TCP 연결 정보', false));
        })
        .finally(() => {
          this.loading.tcp = false;
        });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    exportProtocolList() {
      const me = this;
      if (!isNil(me.params)) {
        netdeviceInfoAPI.exportProtocolInfoList({
          objId: this.nodeParams.objId,
          netdeviceId: this.params.netdeviceId,
        });
      }
    },
    checkDatetimeFormatter(value) {
      return isNil(value) || value === '-' ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/protocol/index.vue